<template lang="pug">
  .slider.js-slider
    .swiper-container(ref="swiperContainer")
      .swiper-wrapper
        .swiper-slide(v-for='item in items', :key="item.id")
          .slider__item(v-on:click="popupLocal('event', 'show', item.id)")
            img.slider-item-image(src="/img/about/slide-img.png" :alt="item.alt || 'Слайд'" loading="lazy")
            .slider__item-bottom
              .slider__item-title
                | {{item.title}}
              .slider__item-date
                | {{item.date}}
              button.slider__item-booking-btn
                | Забронировать
    .swiper-container-bottom
      .swiper-pagination(ref="swiperPagination")
      .swiper-button-prev(ref="swiperButtonPrev")
        SvgIcon(class='slider__arrow-ico' name="arrow-left" width="8" height="16")
      .swiper-button-next(ref="swiperButtonNext")
        SvgIcon(class='slider__arrow-ico' name="arrow-left" width="8" height="16")
</template>




<script>
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
import {determineWindowSize} from '@/mixins/determineWindowSize.js';

export default {
  name: 'Slider',

  mixins: [PopupHelpersVue, determineWindowSize],

  data() {
    return {
      countOfSlideInPage: 3,
      swiperInstance: null
    }
  },

  components: {
    SvgIcon
  },

  props: {
    items: {
      type: Array,
      required: true,
      default: null
    }
  },

  updated() {
    this.determineWindowSize();
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },

  methods: {
    init() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }

      this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: false,
        },
      })

    },


    popupLocal(type, action, id) {
      this.popup(type, action, id);
    }
  }
}
</script>
